/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Dashboard_Load_ErrorInputs */

const en_dashboard_load_error = /** @type {(inputs: Dashboard_Load_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to load tasks checklist: ${i?.message}`)
};

const pt_br2_dashboard_load_error = /** @type {(inputs: Dashboard_Load_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao carregar checklist de atividades: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Failed to load tasks checklist: {message}" |
*
* @param {Dashboard_Load_ErrorInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_load_error = /** @type {((inputs: Dashboard_Load_ErrorInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Load_ErrorInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_load_error(inputs)
	return pt_br2_dashboard_load_error(inputs)
});